export enum SendEmailStatus {
  INIT = 'INIT',

  DONE = 'DONE',

  FAIL = 'FAIL',

  INPROGRESS = 'INPROGRESS',
}
